import { LoggedUserDTO } from './LoggedUserDTO'

export type LoggedUserProps = {
  id: string
  firstName: string
  lastName: string
  email: string
  phone: string
  sessionExpires: Date
  language: string
  clinicsList: string[]
  permissions: string[]
  clinicID: string
  clinicName: string
}

export class LoggedUser {
  private _id: string
  private readonly _firstName: string
  private readonly _lastName: string
  private readonly _email: string
  private readonly _phone: string
  private readonly _language: string
  private readonly _clinicsList: string[]
  private _clinicID: string
  private _sessionExpires: Date
  private readonly _permissions: string[]
  private readonly _clinicName: string

  constructor(p: LoggedUserProps) {
    this._id = p.id
    this._firstName = p.firstName || ''
    this._lastName = p.lastName || ''
    this._email = p.email || ''
    this._phone = p.phone || ''
    this._language = p.language || 'es'
    this._clinicsList = p.clinicsList
    this._sessionExpires = new Date(p.sessionExpires)
    this._permissions = p.permissions
    this._clinicID = p.clinicID
    this._clinicName = p.clinicName
  }

  get id(): string {
    return this._id
  }

  set id(value: string) {
    this._id = value
  }

  get clinicID(): string {
    return this._clinicID
  }

  set clinicID(value: string) {
    this._clinicID = value
  }

  get firstName(): string {
    return this._firstName
  }

  get lastName(): string {
    return this._lastName
  }

  get email(): string {
    return this._email
  }

  get phone(): string {
    return this._phone
  }

  get sessionExpires(): Date {
    return this._sessionExpires
  }

  set sessionExpires(s: Date) {
    this._sessionExpires = s
  }

  get language(): string {
    return this._language
  }

  get clinicsList(): string[] {
    return this._clinicsList
  }

  set sessionExpired(value: Date) {
    this._sessionExpires = value
  }

  get permissions(): string[] {
      return this._permissions;
  }

  get clinicName(): string {
    return this._clinicName
  }

  toDTO(): LoggedUserDTO {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phone: this.phone,
      sessionExpires: this.sessionExpires,
      language: this.language,
      clinicsList: this.clinicsList,
      permissions: this.permissions,
      clinicID: this.clinicID,
      clinicName: this.clinicName
    }
  }
}
